/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { useTour } from "@reactour/tour";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Keyboard, Navigation, Grid } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/grid";
import "swiper/css";

/* 🧩 COMPONENTS */
import { SelectEquipment, Modal, Button, InputCheckbox, Popup, Breadcrumb, InputRadio, Calendar } from "../../../Components";
import { Bardays, CardBar, CardBig, Months, Datepicker } from "../Components";

/* 🔗 SERVICE */
import { EquipamentoService } from "../../../Services/dashboardServices/equipamento";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";
import { store } from "../../../Redux/Store";
import { ChangeDay, ChangeEquipament, ChangeMode, ChangeMonth, changeModal, changePopup, changeyear, ChangeEquipment } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { RelogioIcon, Advertencia, Manutencao, PerdaComunicacao, Critico, Atualizar, Download, Ajuda } from "../../../Assets/icons";
import { ReportIcon } from "../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, Header, ContainerSelect, ContainerTop, ContainerFocusCard, ContainerFocusCardMobile, ContainerCards, ContainerCardsSlim,
    ContainerCardsSlimMobile, ContainerBottom, ContainerBottomMobile, ContainerLeft, StateMonthText, StateContainer, SwiperMobileStyles, 
    CardsLoader, LastUpdateText, LastUpdateIcon, DayIndicator, StateText, ButtonsContainer, SwiperStyles, ContainerType, ButtonType, 
    CalendarButton, UpdateIcon, CalendarContainer, ModalText, SearchInput, AlertIcon, LastUpdateContainer, ImageIcon, OptionsContainer,
    Subtitle, WarningText } from "./styles";
import { HelpIcon } from "../../styles";

/* 🔧 UTILS */
import { getDataString, getLastDay } from "../../../util/Months";
import { GetCardsColor } from "../../../util/Colors";
import { dashboardSteps } from "../../../util/tour/dashboard";

const DashboardEquipamento = () => {
    
    const { t } = useTranslation();
    document.title = t("dashboards.document-title");

    const navigationFlow =  [
        { text: 'dashboard', page: null },
        { text: 'control-system', page: null },
    ]
    
    const { isOpen, setIsOpen, currentStep, setSteps } = useTour();

    let { equipamento } = useParams();
    if(!equipamento){
        equipamento = store.getState().generalReducer.Equipament;
    }

    const statusIconMap = {
        1: Advertencia,
        2: Critico,
        3: PerdaComunicacao,
        4: Manutencao,
    };

    const downloadMethods = [
        {id: 'legacy', label: t("input-radio.legacy")},
        {id: 'newStandard', label: t("input-radio.new-standard")}
    ];

    const downloadExtensions = [
        {id: 'xlsx', label: '.xlsx'},
        {id: 'ods', label: '.ods'},
        {id: 'csv', label: '.csv'},
        {id: 'xls', label: '.xls'},
        {id: 'tsv', label: '.tsv'},
        {id: 'pdf', label: '.pdf'},
        {id: 'html', label: '.html'}
    ];

    const navigate = useNavigate();
    const steps = dashboardSteps(t);
    
    const equipamentoService = useRef(new EquipamentoService());
    const swiperRefWeb = useRef(null);
    const swiperRefMobile = useRef(null);
    const analysisMode = useRef(false);
    const readingMode = useRef(false);
    const method = useRef(downloadMethods[1].id);
    const extension = useRef(downloadExtensions[0].id);
    const calendarButtonRef = useRef(null);

    const day = useSelector(state => state.DashboardEquipamentoReducer.day);
    const days = useSelector(state => state.DashboardEquipamentoReducer.days);
    const month = useSelector(state => state.DashboardEquipamentoReducer.month);
    const year = useSelector(state => state.DashboardEquipamentoReducer.year);
    const cards = useSelector(state => state.DashboardEquipamentoReducer.cards);
    const name = useSelector(state => state.DashboardEquipamentoReducer.name);
    const Mode = useSelector(state => state.DashboardEquipamentoReducer.Mode);
    // const lastUpdate = useSelector(state => state.controlReducer.lastUpdate); // Criar esta flag para dashboard
    const isLoadingCards = useSelector(state => state.DashboardEquipamentoReducer.isLoadingCards);
    const isLoadingDays = useSelector(state => state.DashboardEquipamentoReducer.isLoadingDays);
    const Equipaments = useSelector(state => state.DashboardEquipamentoReducer.Equipamentos);
    const Cities = useSelector(state => state.DashboardEquipamentoReducer.cities);
    const city = useSelector(state => state.DashboardEquipamentoReducer.city);
    const CardStatus = useSelector(state => state.DashboardEquipamentoReducer.CardStatus);
    const equipmentName = useSelector(state => state.DashboardEquipamentoReducer.equipment);
    const isAutoplayEnabled = useSelector(state => state.DashboardEquipamentoReducer.isAutoplayEnabled);

    const [TimeReset, setTimeReset] = useState(getDataString(new Date().getHours()) + ' h ' + getDataString(new Date().getMinutes()) + ' min');

    const [searchItem, setSearchItem] = useState('');
    
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [selectedMethod, setSelectedMethod] = useState(method.current);
    const [selectedMode, setSelectedMode] = useState(null);

    const background = GetCardsColor(CardStatus);
    const iconSrc = statusIconMap[CardStatus];
    const iconColor = background.background;

    useEffect(() => {
        setSteps(steps);
        equipamentoService.current.getEquipamentos();
        equipamentoService.current.getCities();
    }, []);

    useEffect(() => {
        let intervalFunc = setInterval(() => {
            let currentdata = new Date();
            setCurrentDate(currentdata); // Pega a adata atual toda vez que atualiza o equipamento selecionado???
            setTimeReset(getDataString(currentdata.getHours()) + ' h ' + getDataString(currentdata.getMinutes()) + ' min');
            if(parseInt(day) === currentdata.getDate() && 
            parseInt(month) === currentdata.getMonth() + 1 && 
            parseInt(year) === currentdata.getFullYear() && equipamento){
                equipamentoService.current.changeDay(day, month, year)
            }
        }, 300000);
        return () => clearInterval(intervalFunc);
    }, [day, month, year, equipamento]);

    useEffect(() => {
        let timeoutId = 0
        if(equipamento){
            store.dispatch(ChangeEquipament(equipamento))
            equipamentoService.current.start(equipamento);
            timeoutId = setTimeout(() => {
                equipamentoService.current.changeCity(equipamento) 
            }, 5000);
        }
        return () => clearTimeout(timeoutId);
    }, [equipamento]);

    useEffect(() => {
        if(equipamento){
            store.dispatch(ChangeEquipment(Equipaments.find(equipment => equipment.id === equipamento)?.nome));
        }
    }, [Equipaments, equipamento]);

    useEffect(() => {   
        swiperRefWeb.current?.autoplay.stop();
        swiperRefMobile.current?.autoplay.stop();
    }, [isAutoplayEnabled]);

    const handleTour = () => {
        if (!equipamento || !cards[0][0].Active) {
            toast(t("message.dashboards.handle-tour"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        } else {
            setIsOpen(true);
        }
    }

    return (
        <>
            <Container $isTourOpen={isOpen}>
                <Header>
                    <Breadcrumb flow={navigationFlow}/>
                    <LastUpdateContainer>
                        <div className="date-time">
                            <LastUpdateText>{t("control.date", { date: currentDate, format: "dayMonth" })}</LastUpdateText>
                            <LastUpdateText> <LastUpdateIcon src={RelogioIcon}/> {TimeReset} </LastUpdateText>
                        </div>
                        <Button onClick={() => handleTour()} disabled={isLoadingCards} icon={<HelpIcon src={Ajuda} className={"icon"} $disabled={isLoadingCards} />} padding={"8px 10px"} radius={"3px"} width={"44px"}/>
                    </LastUpdateContainer>
                </Header>
                <ContainerSelect>
                    <div className="selects">
                        <SelectEquipment Color={'white'} options={Cities} value={city} onChange={(e) => {
                            store.dispatch(ChangeEquipament())
                            equipamentoService.current.filterEquipaments(e.target.value);
                        }} />
                        <SelectEquipment Color={'white'} options={Equipaments} value={equipamento} onChange={(e) => {
                            if(e.target.value === '' || e.target.value === null || e.target.value === undefined){
                                toast(t("message.select-equipment"), {
                                    position: "top-center",
                                    type: 'info',
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                                return
                            }
                            if(e.target.value === 'geral'){
                                navigate(`/dashboard`);
                            }else{
                                equipamentoService.current.changeCity(e.target.value);
                                store.dispatch(ChangeEquipament(e.target.value));
                                store.dispatch(ChangeEquipment(Equipaments.find(equipment => equipment.id === e.target.value)?.nome));
                                navigate(`/dashboard/${e.target.value}`);
                            }
                        }} />
                    </div>
                        <div className="report-buttons-container">
                            {equipamento && (Equipaments?.find(e => e.id === equipamento)?.type?.id === "1f4d0674-1e7a-48c5-925f-87e2d99bcda5") && (
                                <Button text={t("buttons.reporting")} icon={<ImageIcon src={Download}/>} padding={'14px'} onClick={() => store.dispatch(changeModal('reporting'))}/>
                            )}
                            <Button text={t("buttons.reports")} id={"reports-button"} disabled={isOpen && currentStep === 0} icon={<ImageIcon src={ReportIcon} fill={(isOpen && currentStep === 0) ? 'disabled' : 'undefined'} />} padding={'14px'} onClick={() => store.dispatch(changeModal('reports'))}/>
                        </div>
                </ContainerSelect>

                <DayIndicator>
                    <StateText> {t("dashboards.header-title", { date: currentDate })} </StateText>
                    {equipamento && <CalendarButton id="calendar-popup-button" disabled={isOpen && currentStep === 3} onClick={() => store.dispatch(changePopup('calendar'))} ref={calendarButtonRef}>
                        <UpdateIcon src={Atualizar} color={'#333'}/>
                        </CalendarButton>}
                </DayIndicator>
                
                <ContainerTop>
                    <ContainerLeft id="change-fav-cards">
                        <ContainerFocusCard>
                            {cards[0].map((card, index) => (
                                card.focus ?
                                    <CardBig key={index} Bar={<CardBar valor={card['campo%']?.valor} Color={card.status ? card.status : 0} Focus={true}/>}  isfav={true}
                                Title={card?.name} Color={card.status ? card.status : 0} Active={card?.Active !== false} Focus={true} valor={card?.campoValor?.valor} 
                                porcentagem={card['campo%']?.valor} unidade={card?.campoValor?.unidade} descricao={card['campo%']?.unidade}
                                removeFAV={() => equipamentoService.current.removeFAV(index)} PutCard={() => equipamentoService.current.changeFavCard(index, true)}
                                onClick={() => console.log('em foco')} isLoading={isLoadingCards} id={["fav-card", "unpin-icon", "empty-space"]}/>
                                : null
                            ))}
                        </ContainerFocusCard>

                        <ContainerFocusCardMobile>
                            {cards[0].map((card, index) => (
                                card.focus ?
                                    <CardBig key={index} Bar={<CardBar valor={card['campo%']?.valor} Color={card.status ? card.status : 0} Focus={true}/>} isfav={true} 
                                Title={card?.name} Color={card.status ? card.status : 0} Active={card?.Active !== false} Focus={true} valor={card?.campoValor?.valor} 
                                removeFAV={() => equipamentoService.current.removeFAV(index)} PutCard={() => equipamentoService.current.changeFavCard(index, true)}
                                porcentagem={card['campo%']?.valor} unidade={card?.campoValor?.unidade} descricao={card['campo%']?.unidade}
                                onClick={() => console.log('em foco')} isLoading={isLoadingCards} id={["fav-card-mobile", "unpin-icon-mobile", "empty-space"]}/>
                                : null
                            ))}
                        </ContainerFocusCardMobile>

                        <ContainerCards>
                            {cards[0].map((card, index) => (
                                !card.focus && index < 5 ?
                                    <CardBig key={index} index={index} Bar={<CardBar valor={card['campo%']?.valor} Color={card.status ? card.status : 0}/>}  isfav={true}
                                Title={card?.name} Color={card.status ? card.status : 0} Active={card?.Active !== false} Focus={false} valor={card?.campoValor?.valor} 
                                isLoading={isLoadingCards} removeFAV={() => equipamentoService.current.removeFAV(index)}
                                porcentagem={card['campo%']?.valor} unidade={card?.campoValor?.unidade} descricao={card['campo%']?.unidade}
                                onClick={() => equipamentoService.current.changeFocus(card.id, index, card.key, card.idEquipment)} 
                                PutCard={() => equipamentoService.current.changeFavCard(index, false)} id={["fav-card", "unpin-icon", "empty-space", "unpin-card"]}/>
                                : null
                            ))}
                        </ContainerCards>
                    </ContainerLeft>

                    <ContainerBottomMobile id="bardays-landscape" $border={GetCardsColor(CardStatus).border}>
                        <StateContainer>
                            <StateMonthText> 
                                {iconSrc && <AlertIcon src={iconSrc} color={iconColor} />}
                                {name} 
                            </StateMonthText>
                            <ContainerType>
                                <div id="bardays-landscape-buttons">
                                    <ButtonType disabled={equipamento === null || isLoadingDays || Mode === 0} $selected={Mode === 0} color={GetCardsColor(CardStatus).background} onClick={() => {
                                        store.dispatch(ChangeMode(0))
                                        equipamentoService.current.getHoursData();
                                    }}>{t("dashboards.state-component.monthly")}</ButtonType>
                                    <ButtonType disabled={equipamento === null || isLoadingDays || Mode === 1} $selected={Mode === 1}  color={GetCardsColor(CardStatus).background}  onClick={() => {
                                        store.dispatch(ChangeMode(1))
                                        equipamentoService.current.getHoursData();
                                    }}>{t("dashboards.state-component.daily")}</ButtonType>
                                </div>
                                <div id="datepicker-landscape-button">
                                    {equipamento && <Datepicker id={"datepicker"} currentDate={currentDate} setCurrentDate={setCurrentDate} 
                                    day={day} month={month} year={year} isLoadingDays={isLoadingDays} Mode={Mode}
                                    changeDay={(day) => {
                                        store.dispatch(ChangeDay(day));
                                        equipamentoService.current.changeDay(day, month, year)
                                    }}
                                    changeMonthYear={(day, month, year) => {
                                        store.dispatch(ChangeDay(day));
                                        store.dispatch(ChangeMonth(month));
                                        store.dispatch(changeyear(year));
                                        equipamentoService.current.changeMonthYear(day, month, year)
                                    }}
                                    />}
                                </div>                              
                            </ContainerType>
                        </StateContainer>
                        <Bardays month={month} year={year} days={days} day={day} 
                        type={'graph'}
                        Mode={parseInt(Mode)}
                        CardStatus={CardStatus}
                        disabled={equipamento === null} isLoading={isLoadingDays}
                        ChangeDays={(currentday) => {
                            store.dispatch(ChangeDay(currentday))
                            equipamentoService.current.changeDay(currentday, month, year)
                        }}/>
                        <Months 
                            id={"today-button-landscape"}
                            CardStatus={CardStatus}
                            disabled={equipamento === null || isLoadingDays}
                            ChangeMonths={(currentmonth) => {
                                store.dispatch(ChangeMonth(currentmonth));
                                store.dispatch(ChangeDay(getLastDay(currentmonth, year)));
                                equipamentoService.current.changeMonthYear(getLastDay(currentmonth, year), currentmonth, year);
                            }}
                            ChangeMode={(mode) => {
                                store.dispatch(ChangeMode(mode))
                                equipamentoService.current.getHoursData();
                            }}
                            showDayButton={parseInt(day) !== new Date().getDate() ||
                                parseInt(month) !== new Date().getMonth()+1 || 
                                parseInt(year) !== new Date().getFullYear()}
                            BackToday={() => {
                                equipamentoService.current.changeMonthYear(getDataString(new Date().getDate()), getDataString(new Date().getMonth()+1), new Date().getFullYear())
                                store.dispatch(ChangeDay(getDataString(new Date().getDate())))
                                store.dispatch(ChangeMonth(getDataString(new Date().getMonth()+1)))
                                store.dispatch(changeyear(new Date().getFullYear()))
                            }}
                            currentmonth={parseInt(month)-1}
                            year={year}
                            Changeyear={(currentyear) => {
                                store.dispatch(changeyear(currentyear))
                                equipamentoService.current.changeMonthYear(day, month, currentyear)
                            }}
                        />
                    </ContainerBottomMobile>

                    <ContainerCardsSlim>
                        <SearchInput
                            id="search-card"
                            aria-label={t("inputs.search-card.alt")}
                            type="text"
                            placeholder={t("inputs.search-card.placeholder")} 
                            value={searchItem}
                            disabled={!equipamento || isLoadingCards || (isOpen && currentStep === 12)}
                            onChange={(e) => {
                                setSearchItem(e.target.value);
                                equipamentoService.current.FilterCards(e.target.value);
                            }}
                        />
                        {isLoadingCards ?
                            <CardsLoader>
                                {[1, 2, 3, 4].map((_, index) => (
                                    <CardBig key={index} Active={false} isLoading={isLoadingCards}/>
                                ))}
                            </CardsLoader>
                        : cards[1].length > 0 &&
                            <Swiper
                                // ()=> swiperRef.current?.autoplay.start()
                                id="swiper"
                                ref={swiperRefWeb}
                                onSwiper={swiper => swiperRefWeb.current = swiper}
                                onResize={(swiper) => {swiper.update()}}
                                style={SwiperStyles}
                                grid={{
                                    rows: 2,
                                }}
                                slidesPerView={3}
                                grabCursor={true}
                                modules={[Autoplay, Grid, Pagination, Keyboard, Navigation]}
                                pagination={{ clickable: true }}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                keyboard={{enabled: true}}
                                autoplay={{delay: 5000, disableOnInteraction: true, pauseOnMouseEnter: true}}
                                >
                                {cards[1]?.map((card, index) => (
                                    !card.focus ?
                                    <SwiperSlide key={index}>
                                        <CardBig key={index} index={index} Bar={<CardBar valor={card['campo%']?.valor} Color={card.status ? card.status : 0} />} 
                                            Title={card?.name} Color={card.status ? card.status : 0} Active={card.Active !== false} Focus={false} valor={card?.campoValor?.valor} 
                                            hasMore = {false} isLoading={isLoadingCards}
                                            porcentagem={card['campo%']?.valor} unidade={card?.campoValor?.unidade} descricao={card['campo%']?.unidade}
                                            onClick={() => equipamentoService.current.AddFav(card.id, card.key, card.idEquipment)} />
                                    </SwiperSlide>
                                    : null
                                ))}
                                <div className="swiper-button-next" style={{ display: 'block', right: 0, top: '200px'}}></div>
                                <div className="swiper-button-prev" style={{ display: 'block', left: 0, top: '200px'}}></div>
                            </Swiper>
                        } 
                    </ContainerCardsSlim>

                </ContainerTop>

                <ContainerBottom id="bardays" $border={GetCardsColor(CardStatus).border}>
                    <StateContainer>
                        <StateMonthText> 
                            {iconSrc && <AlertIcon src={iconSrc} color={iconColor} />}
                            {name} 
                        </StateMonthText>                   

                        <ContainerType>
                            <div id="bardays-buttons">
                                <ButtonType disabled={equipamento === null || isLoadingDays || Mode === 0} $selected={Mode === 0} color={GetCardsColor(CardStatus).background} onClick={() => {
                                    store.dispatch(ChangeMode(0));
                                    equipamentoService.current.getHoursData();
                                }}>{t("dashboards.state-component.monthly")}</ButtonType>
                                <ButtonType disabled={equipamento === null || isLoadingDays || Mode === 1} $selected={Mode === 1} color={GetCardsColor(CardStatus).background}  onClick={() => {
                                    store.dispatch(ChangeMode(1));
                                    equipamentoService.current.getHoursData();
                                }}>{t("dashboards.state-component.daily")}</ButtonType>
                            </div>
                            <div id="datepicker-button">
                                {equipamento && <Datepicker id={"datepicker"} currentDate={currentDate} setCurrentDate={setCurrentDate} 
                                    day={day} month={month} year={year} isLoadingDays={isLoadingDays} Mode={Mode}
                                    changeDay={(day) => {
                                        store.dispatch(ChangeDay(day));
                                        equipamentoService.current.changeDay(day, month, year)
                                    }}
                                    changeMonthYear={(day, month, year) => {
                                        store.dispatch(ChangeDay(day));
                                        store.dispatch(ChangeMonth(month));
                                        store.dispatch(changeyear(year));
                                        equipamentoService.current.changeMonthYear(day, month, year);
                                    }}
                                />}
                            </div>
                        </ContainerType>
                    </StateContainer>

                    <Bardays month={month} year={year} days={days} day={day} 
                    type={'graph'}
                    Mode={parseInt(Mode)}
                    CardStatus={CardStatus}
                    disabled={equipamento === null} isLoading={isLoadingDays}
                    ChangeDays={(currentday) => {
                        store.dispatch(ChangeDay(currentday))
                        equipamentoService.current.changeDay(currentday, month, year)
                    }}/>
                    <Months 
                        id={"today-button"}
                        CardStatus={CardStatus}
                        disabled={equipamento === null || isLoadingDays}
                        ChangeMonths={(currentmonth) => {
                            store.dispatch(ChangeMonth(currentmonth));
                            store.dispatch(ChangeDay(getLastDay(currentmonth, year)));
                            equipamentoService.current.changeMonthYear(getLastDay(currentmonth, year), currentmonth, year);
                        }}
                        showDayButton={parseInt(day) !== new Date().getDate() || 
                            parseInt(month) !== new Date().getMonth() + 1 || 
                            parseInt(year) !== new Date().getFullYear()}
                        BackToday={() => {
                            let date = new Date();
                            setCurrentDate(date);
                            equipamentoService.current.changeMonthYear(getDataString(date.getDate()), getDataString(date.getMonth() + 1), date.getFullYear());
                            store.dispatch(ChangeDay(getDataString(date.getDate())));
                            store.dispatch(ChangeMonth(getDataString(date.getMonth() + 1)));
                            store.dispatch(changeyear(date.getFullYear()));
                        }}
                        ChangeMode={(mode) => {
                            store.dispatch(ChangeMode(mode));
                            equipamentoService.current.getHoursData();
                        }}
                        currentmonth={parseInt(month) - 1}
                        year={year}
                        Changeyear={(currentyear) => {
                            store.dispatch(changeyear(currentyear));
                            equipamentoService.current.changeMonthYear(day, month, currentyear);
                        }}
                    />
                </ContainerBottom>

                <ContainerCardsSlimMobile>
                    <SearchInput
                        id="search-card-mobile" 
                        aria-label={t("inputs.search-card.alt")}
                        type="text"
                        placeholder={t("inputs.search-card.placeholder")}
                        value={searchItem}
                        disabled={!equipamento}
                        onChange={(e) => {
                            setSearchItem(e.target.value);
                            equipamentoService.current.FilterCards(e.target.value);
                        }}
                    />
                    {isLoadingCards ?
                            [1, 2, 3, 4].map((_, index) => (
                                <CardBig key={index} Active={false} isLoading={isLoadingCards}/>
                            ))
                        :
                            cards[1].length > 0 &&
                            <Swiper
                                id="swiper-mobile"
                                ref={swiperRefMobile}
                                onSwiper={swiper => swiperRefMobile.current = swiper}
                                onResize={(swiper) => swiper.update()}
                                style={SwiperMobileStyles}
                                grid={{
                                    rows: 1,
                                }}
                                slidesPerView={3}
                                grabCursor={true}
                                modules={[Autoplay, Pagination, Keyboard, Navigation, Grid]}
                                pagination={{clickable: true}}
                                navigation={{
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev',
                                }}
                                keyboard={{enabled: true}}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: true,
                                }}
                                >

                                {cards[1]?.map((card, index) => (
                                    !card.focus ?
                                    <SwiperSlide key={index} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <CardBig key={index} index={index} Bar={<CardBar valor={card['campo%']?.valor} Color={card.status ? card.status : 0} />} 
                                            Title={card?.name} Color={card.status ? card.status : 0} Active={card.Active !== false} Focus={false} valor={card?.campoValor?.valor} 
                                            hasMore = {false} isLoading={isLoadingCards}
                                            porcentagem={card['campo%']?.valor} unidade={card?.campoValor?.unidade} descricao={card['campo%']?.unidade}
                                            onClick={() => equipamentoService.current.AddFav(card.id, card.key, card.idEquipment)} />
                                    </SwiperSlide>
                                    : null
                                ))}
                                <div className="swiper-button-next" style={{ display: 'block', top:'50px', right:0 }}></div>
                                <div className="swiper-button-prev" style={{ display: 'block', top:'50px', left: 0 }}></div>
                            </Swiper>
                        }
                </ContainerCardsSlimMobile>

            </Container>
            <Popup title={t("popup.date-picker")} id={"calendar-popup"} name={'calendar'} buttonRef={calendarButtonRef}>
                <Calendar container={'popup'} selectedDate={selectedDate} onDateChange={setSelectedDate} changeDay={(day) => {
                    equipamentoService.current.changeDay(day, month, year);
                }}/>
                <ButtonsContainer $justify={'space-between'} $width={100}>
                    <Button text={t("buttons.cancel")} width={'100px'} padding={'10px'} color={'white-red'} disabled={isOpen && currentStep === 4} onClick={() => store.dispatch(changePopup(''))}/>
                    <Button text={t("buttons.confirm")} width={'100px'} padding={'10px'}  disabled={isOpen && currentStep === 4}
                    onClick={() => {
                        if(getDataString(selectedDate.getMonth()+1) === month &&
                        selectedDate.getFullYear() === year && parseInt(Mode) === 0){
                                store.dispatch(ChangeDay(selectedDate.getDate()));
                                equipamentoService.current.changeDay(
                                    getDataString(selectedDate.getDate()),
                                    getDataString(selectedDate.getMonth()+1),
                                    selectedDate.getFullYear()
                                );
                        
                        }else{
                            store.dispatch(ChangeDay(getDataString(selectedDate.getDate())));
                            store.dispatch(ChangeMonth(getDataString(selectedDate.getMonth() + 1)));
                            store.dispatch(changeyear(selectedDate.getFullYear()));
                            equipamentoService.current.changeMonthYear(
                                getDataString(selectedDate.getDate()),
                                getDataString(selectedDate.getMonth() + 1),
                                selectedDate.getFullYear()
                            );
                        }
                        setCurrentDate(selectedDate);
                        store.dispatch(changePopup(''));
                    }}/>
                </ButtonsContainer>
            </Popup>   

            <Modal title={t("modal.report.title")} name={'reporting'} width={'740px'} height={'78%'}>                
                <CalendarContainer>
                    <Calendar title={t("calendar.title.initial-date")}  selectedDate={initialDate} onDateChange={setInitialDate} />
                    <Calendar title={t("calendar.title.final-date")} selectedDate={finalDate} onDateChange={setFinalDate}/>
                </CalendarContainer>
                <Button text={t("buttons.reporting")} width={'100%'} disabled={isOpen && currentStep === 1} onClick={() => {equipamentoService.current.getReport(equipamento, initialDate.toISOString().slice(0, 10)+'T00:00', finalDate.toISOString().slice(0, 10)+'T23:59:59')}}/> 
            </Modal>

            <Modal title={t("modal.report.title")} id={"reports-modal"} name={'reports'} width={'780px'} height={'90%'}>                
                <CalendarContainer>
                    <Calendar title={t("calendar.title.initial-date")}  selectedDate={initialDate} onDateChange={setInitialDate} />
                    <Calendar title={t("calendar.title.final-date")} selectedDate={finalDate} onDateChange={setFinalDate}/>
                </CalendarContainer>
                <OptionsContainer>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.setup-file")}:</Subtitle>
                        <div className="file-setup">
                            <InputCheckbox text={t("checkbox.analysis-mode")} checked={analysisMode.current} onChange={(value) => {analysisMode.current = value; return true}}/>
                            <InputCheckbox text={t("checkbox.reading-mode")} checked={readingMode.current} disabled={selectedMethod === downloadMethods[0].id} onChange ={(value) => {readingMode.current = value; setSelectedMode(value); return true}}/>
                        </div>
                        {selectedMode &&
                            <WarningText $float={'right'}>
                                *{t("modal.report.warnings.option-not-available")}
                            </WarningText>
                        }
                    </div>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.spreadsheet-type")}:</Subtitle>
                        <div className="spreadsheet-setup">
                            <InputRadio name={'method'} options={downloadMethods} value={downloadMethods[1].id} 
                            onChange ={(value) => {method.current = value; setSelectedMethod(value); return true}}/>
                        </div>
                    </div>
                    <div className="container">
                        <Subtitle>{t("modal.report.subsections-title.format")}:</Subtitle>
                        <div className="file-format">
                            <InputRadio name={'format'} options={downloadExtensions} value={downloadExtensions[0].id} disabled={selectedMethod === downloadMethods[0].id ? [1, 2, 3, 4, 5, 6] : (selectedMode ? [5, 6] : [])} onChange={(value) => {extension.current = value; return true}}/>
                        </div>
                        {selectedMethod === downloadMethods[0].id &&
                            <WarningText $float={'right'}>
                                *{t("modal.report.warnings.compatible-format")}
                            </WarningText>
                        }
                        
                    </div>
                </OptionsContainer>

                <ButtonsContainer $justify={'space-between'} id="download-restrictions" $sendToEmail={(((new Date(finalDate) - new Date(initialDate)) / (1000 * 60 * 60 * 24)) > 45 && (selectedMethod !== downloadMethods[0].id)) || (currentStep === 2)}>
                    <Button 
                        text={t("buttons.send-by-email")} 
                        icon={<ImageIcon className={"icon"} src={Download} fill={"greenWhite"}/>} 
                        width={'220px'} 
                        disabled={isOpen && (currentStep === 1 || currentStep === 2)} 
                        onClick={() => {
                            const startDate = `${initialDate.toISOString().slice(0, 10)}T00:00`;
                            const endDate = `${finalDate.toISOString().slice(0, 10)}T23:59:59`;
                            const methodOld = method.current === 'legacy';
                            
                            equipamentoService.current.getExcel(
                                equipamento,
                                startDate,
                                endDate,
                                analysisMode.current,
                                readingMode.current,
                                methodOld,
                                extension.current
                            );
                        }}
                    />
                    <Button 
                        text={t("buttons.download")} 
                        icon={<ImageIcon className={"icon"} src={Download} fill={(isOpen && (currentStep === 1 || currentStep === 2)) || (((new Date(finalDate) - new Date(initialDate)) / (1000 * 60 * 60 * 24)) > 45) ? "disabled" : "greenWhite"}/>} 
                        width={'220px'} 
                        disabled={(isOpen && (currentStep === 1 || currentStep === 2)) || (((new Date(finalDate) - new Date(initialDate)) / (1000 * 60 * 60 * 24)) > 45)} 
                        onClick={() => {
                            const startDate = `${initialDate.toISOString().slice(0, 10)}T00:00`;
                            const endDate = `${finalDate.toISOString().slice(0, 10)}T23:59:59`;
                            const methodOld = method.current === 'legacy';
                            
                            equipamentoService.current.getExcel(
                                equipamento,
                                startDate,
                                endDate,
                                analysisMode.current,
                                readingMode.current,
                                methodOld,
                                extension.current
                            );
                        }}
                    />
                </ButtonsContainer>
                {((new Date(finalDate) - new Date(initialDate)) / (1000 * 60 * 60 * 24)) > 45 && (selectedMethod !== downloadMethods[0].id) &&
                    <WarningText>
                        *{t("modal.report.warnings.long-period")}
                    </WarningText>
                }
            </Modal>

            <Modal title={t("modal.report.title")} name={'report'} width={'50%'} height={'26%'}>                   
                <ModalText>
                    {t("modal.report.content.success", { equipment: equipmentName })}  <br />
                    {t("modal.report.content.date", { initialDate, finalDate})}  <br />
                    {t("modal.report.content.report")}
                </ModalText>
            </Modal>

            <Modal title={t("modal.report.title")} name={'download'} width={'50%'} height={'26%'}>                   
                <ModalText>
                    {t("modal.report.content.success", { equipment: equipmentName})}  <br />
                    {t("modal.report.content.date", { initialDate, finalDate})}  <br />
                    {t("modal.report.content.download")}
                </ModalText>
            </Modal>

            <Modal title={t("modal.report.title")} name={'visualization'} width={'50%'} height={'26%'}>                   
                <ModalText>
                    {t("modal.report.content.success", { equipment: equipmentName })}  <br />
                    {t("modal.report.content.date", { initialDate, finalDate})}  <br />
                    {t("modal.report.content.visualization")}
                </ModalText>
            </Modal>
        </>
    );
}

export default DashboardEquipamento;
